module.exports = __webpack_public_path__ + "static/KmnLogo-43d75a270c511910c8370cc536e078a5.png";